import React from "react";
import style from "./AllPost.module.css";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
const PostCard = ({ post }) => {
  const textPost = parse(post.post.slice(0, 20));
  return (
    <Link to={`/post/${post.id}`} className={style.link_post}>
      <div
        className={`card mb-3 ${style.card_post}`}
        style={{ maxWidth: "98%" }}
      >
        <div className="row g-0">
          <div className="col-md-9">
            <div className="card-body">
              <h5 className={`card-title ${style.title_text}`}>{post.judul}</h5>
              <p className="card-text">{textPost}</p>
              <p className="card-text">
                <small className="text-muted">
                  {" "}
                  {new Date(post.updated_at).toLocaleDateString()}
                </small>
              </p>
            </div>
          </div>
          <div className="col-md-3">
            <img
              src={`${process.env.REACT_APP_LINK}/foto/${post.foto}`}
              className={`img-fluid rounded-start ${style.imagePost}`}
              alt="..."
            />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PostCard;
